import React, {Fragment} from 'react';

const UnableUpdateStep = () => {
  return (
    <Fragment>
      <div>
        <b>Unable to update</b><p/>
        It is not possible to update your scanner automatically. Please contact your customer support desk.<p/>
        You can now close this window.
      </div>
    </Fragment>
  );
};

export default UnableUpdateStep;
